import AOS from 'aos';

const Animate = () => {

    document.addEventListener('DOMContentLoaded', function() {
        var blocks = document.querySelectorAll('.block');
        blocks.forEach(function(block) {
            var blockId = block.getAttribute('id');
            if (!blockId) {
                blockId = generateRandomBlockId();
                block.setAttribute('id', blockId);
            }

            // set initial delay value
            var delay = 200;

            var cards = block.querySelectorAll('.animate');
            if (cards) {
                cards.forEach(function(card) {

                    // check if card exists and doesnt already have data attributes added
                    if (card && !card.hasAttribute('data-aos')) {
                        card.setAttribute('data-aos-delay', delay);
                        card.setAttribute('data-aos-duration', '300');
                        card.setAttribute('data-aos-anchor', '#' + blockId);
                        card.setAttribute('data-aos-offset', '0');
               
                        // Check for the animate type class and extract the animation type
                        var animationTypeClass = Array.from(card.classList).find(cls => cls.startsWith('animate--'));
                        if (animationTypeClass) {
                            // Extract the part after 'animate--' to set it as data-aos attribute value
                            var animationType = animationTypeClass.replace('animate--', '');
                            card.setAttribute('data-aos', animationType);
                        } else {
                            // if not type is set, default to fade-in
                            card.setAttribute('data-aos', 'fade-in');
                        }
                    }
                    delay += 200
                });
            } 
        });

        // Function to generate a random string of 20 characters
        function generateRandomBlockId() {
            var characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
            var result = '';
            for (var i = 0; i < 20; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        }

        // Initialise AOS after updating the data attributes
        AOS.init();
    });
}

export default Animate;